import { render, staticRenderFns } from "./widgetSecRealtimeThreat.vue?vue&type=template&id=f22dcb82&scoped=true&"
import script from "./widgetSecRealtimeThreat.vue?vue&type=script&lang=js&"
export * from "./widgetSecRealtimeThreat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22dcb82",
  null
  
)

export default component.exports